import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import './ServicePage.css';

const FullStackMobileApp = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
    window.scrollTo(0, 0);
  }, []);

  const features = [
    'Android + iOS apps',
    'Custom UI/UX',
    'Backend (Node.js + Express)',
    'Database (MongoDB/Firebase)',
    'Authentication (Email/OTP/OAuth)',
    'Payments & notifications',
    'Admin dashboards',
    'Deployment to Play Store & App Store'
  ];

  const idealFor = [
    'Startups',
    'Booking apps',
    'Delivery apps',
    'Social apps',
    'Business apps',
    'SaaS mobile apps'
  ];

  return (
    <div className="service-page">
      <Navbar />
      <div className="service-hero">
        <Link to="/" className="back-button" data-aos="fade-right">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="service-hero-content" data-aos="fade-up">
          <h1 className="service-page-title">Full-Stack Mobile App Development</h1>
          <p className="service-hero-tagline">Modern mobile applications powered by solid backends.</p>
        </div>
      </div>

      <div className="service-content">
        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Overview</h2>
          <p className="section-text">
            We build dynamic, full-stack mobile apps with complete backend systems — including dashboards, APIs, 
            authentication, and live data features.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">What You Get</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-item" data-aos="fade-up" data-aos-delay={index * 50}>
                <FaCheck className="check-icon" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Ideal For</h2>
          <div className="ideal-for-list">
            {idealFor.map((item, index) => (
              <div key={index} className="ideal-item" data-aos="fade-up" data-aos-delay={index * 100}>
                {item}
              </div>
            ))}
          </div>
        </div>

        <div className="service-cta" data-aos="fade-up">
          <Link to="/contact" className="cta-button-primary">
            Start Your Mobile App Project →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FullStackMobileApp;

